@import 'node_modules/@gaiads/telia-react-component-library/build/styles/colors';
@import '../../breakpoints';
@import '../../fonts';

$top-bar-height: 38px;
$main-container-height: 72px;
$segment-links-height: 52px;
$language-links-height: 70px;

$menu-item-level-1-background-color: color(white);
$menu-item-level-2-background-color: color(white);
$menu-item-level-3-background-color: color(gray100);
$menu-item-active-color: color(purple500);

$menu-item-level-2-hover-background-color: color(gray200);
$menu-item-level-3-hover-background-color: color(gray200);

$menu-item-level-2-selected-background-color: color(gray100);

$menu-item-mobile-level-1-background-color: color(gray200);
$menu-item-mobile-level-2-background-color: color(white);
$menu-item-mobile-level-3-background-color: color(white);

$menu-item-mobile-level-1-selected-background-color: color(white);

.menu {
  & ::-moz-focus-inner {
    border: 0;
  }

  .menu_item > & {
    overflow: hidden;
    flex-direction: column;
    display: flex;
    max-height: 0;
    transition: max-height 0.2s, transform 0s ease-out 0.2s;
    transform: scale(0);

    @include from('md') {
      overflow: visible;
      transform-origin: 0 0;
      transition: transform 0.2s;
      transform: scaleY(0);

      &__level3 {
        transform: scaleX(0);
      }
    }
  }

  .menu_item__selected > & {
    max-height: 1000px;
    transform: scale(1);
    transition: max-height 0.2s, transform 0s ease-out 0s;

    @include from('md') {
      overflow: visible;
      transition: transform 0.2s;
      transform: scaleY(1);
      max-height: none;

      &__level3 {
        transform: scaleX(1);
      }
    }
  }

  // Level 1 menu
  &__level1 {
    // TODO: use stronger selector instead of !important
    flex-direction: column !important;
    position: relative;

    @include from('md') {
      flex-direction: row !important;
      flex-wrap: wrap;
      height: 40px;
      margin-top: 5px !important;
    }
  }

  // Level 2 menu
  &__level2 {
    position: relative;

    @include from('md') {
      position: absolute;
      top: 52px;
      left: -12px;
    }
  }

  // Level 3 menu
  &__level3 {
    position: relative;

    @include from('md') {
      position: absolute;
      top: 0px;
      left: 230px;
    }
  }

  &_item {
    background-color: red;
    box-sizing: border-box;
    text-align: left;
    position: relative;
    transition: background-color 0.1s ease-out 0.05s;

    @include from('md') {
      transition: background-color 0s;
    }

    // Level 1 menu item
    &__level1 {
      position: relative;
      color: color(black);
      border-bottom: solid 1px color(gray300);
      overflow: hidden;
      background-color: $menu-item-mobile-level-1-background-color;

      &.menu_item__selected {
        overflow: visible;
        background-color: $menu-item-mobile-level-1-selected-background-color;
        transition: background-color 0s;
      }

      @include from('md') {
        height: 40px;
        border-bottom: none;
        overflow: visible;
        background-color: $menu-item-level-1-background-color;
      }
    }

    // Level 2 menu item
    &__level2 {
      line-height: 20px;
      padding: 0;
      background-color: $menu-item-mobile-level-2-background-color;

      @include to('sm') {
        &:last-child {
          & .menu_item:last-child {
            padding-bottom: 0px;
          }

          padding-bottom: 16px;
        }
      }

      @include from('md') {
        line-height: 20px;
        border-bottom: solid 1px color(gray300);
        background-color: $menu-item-level-2-background-color;

        &.menu_item__selected {
          background-color: $menu-item-level-2-selected-background-color;
        }

        &:hover {
          background-color: $menu-item-level-2-hover-background-color;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }

    // Level 3 menu item
    &__level3 {
      line-height: 20px;
      padding: 0;
      background-color: $menu-item-mobile-level-3-background-color;

      @include to('sm') {
        &:last-child {
          padding-bottom: 16px;
        }
      }

      @include from('md') {
        line-height: 20px;
        border-bottom: solid 1px color(gray300);
        background-color: $menu-item-level-3-background-color;

        &:hover {
          background-color: $menu-item-level-3-hover-background-color;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

  &_itemButton {
    background-color: transparent;
    width: 100%;

    &__level1 {
      line-height: 70px;
    }

    // TODO: use stronger selector instead of !important
    &:focus {
      outline-offset: -4px !important;
      outline: auto solid 4px color(blue500) !important;
    }
    &:focus:not(:focus-visible) {
      outline: 0 !important;
    }
  }

  &_itemText {
    background-color: transparent;
    @include helvetica;
    display: flex;
    box-sizing: border-box;
    align-items: baseline;
    justify-content: space-between;
    color: color(black);
    user-select: none;
    cursor: pointer;
    text-align: left;

    &:focus {
      outline-offset: -4px !important;
      outline: auto solid 4px color(blue500) !important;
    }

    &:focus:not(:focus-visible) {
      outline: 0 !important;
    }

    // Level 1 menu item text
    &__level1 {
      padding: 0;
      font-size: 18px;
      font-weight: 500;

      @include from('md') {
        padding: 0 12px;
        font-size: 16px;
        font-weight: normal;
        line-height: 35px;

        // TODO: use stronger selector instead of !important
        * {
          line-height: 35px !important;
        }

        // TODO: Disable hover effect for mobile devices
        // @include hover-supported {
        //  color: color(purple500);
        //}
      }

      .menu_item__level1.menu_item__selected & {
        @include from('md') {
          color: color(purple500);
        }
      }
    }

    // Level 2 menu item text
    &__level2 {
      font-size: 14px;
      font-weight: 500;
      border-top: solid 1px color(gray300);
      padding: 14px 0 14px 24px;

      @include from('md') {
        width: 230px;
        font-size: 16px;
        font-weight: normal;
        border-top: none;
        padding: 17px 18px 17px 24px;
      }
    }

    // Level 3 menu item text
    &__level3 {
      font-size: 14px;
      font-weight: normal;
      padding: 10px 0 10px 48px;

      @include from('md') {
        width: 230px;
        font-size: 16px;
        font-weight: normal;
        border-top: none;
        padding: 17px 18px 17px 24px;
      }
    }
  }

  &_dropdownIcon {
    transition: transform 0.2s;

    // Level 1 dropdown icon
    &__level1 {
      transform: rotate(0deg);
      border-radius: 50%;
      line-height: 0px;
      font-size: 16px;
      background-color: color(gray200);
      margin-right: -9px;
      padding: 9px;

      @include from('md') {
        font-size: 10px;
        background-color: transparent;
        padding: 0px;
        margin-right: 0;
        margin-left: 8px;
      }

      .menu_item__level1.menu_item__selected & {
        transform: rotate(-180deg);
      }
    }

    // Level 2 dropdown icon
    &__level2 {
      transform: rotate(0deg);
      border-radius: 50%;
      line-height: 0px;
      font-size: 10px;
      background-color: color(white);
      margin-right: -4px;
      padding: 4px;

      @include from('md') {
        transition: transform 0s;
        margin-right: 0;
        transform: rotate(-90deg);
        background-color: transparent;
      }

      .menu_item__level2.menu_item__selected & {
        transform: rotate(-180deg);
        background-color: color(gray200);

        @include from('md') {
          transform: rotate(-90deg);
          background-color: transparent;
        }
      }
    }

    // There should never be a level 3 dropdown icon as one should not create a menu that deep
  }
}

.menu_item__level1 > .menu_item__active {
  position: relative;
  @include from('md') {
    &::after {
      content: '';
      display: block;
      height: 2px;
      bottom: 0;
      left: 12px;
      right: 12px;
      background-color: $menu-item-active-color;
      position: absolute;
    }
  }
}
